import React from 'react';
import UFOSegment from '@atlaskit/react-ufo/segment';
import { TopNav as AkTopNav } from '@atlaskit/navigation-system/layout/top-nav';

import { TopNavigationBase } from '@confluence/app-navigation/entry-points/topNavigation.tsx';
import { useCustomTheme } from '@confluence/app-navigation/entry-points/useCustomTheme.ts';
import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay.ts';

import { LazyImpersonationFlag } from './impersonation/LazyImpersonationFlag.tsx';
import type { ThemeQuery as ThemeQueryData } from './__types__/ThemeQuery.ts';
import ThemeQuery from './__generated__/ThemeQuery.graphql.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
type TopNavProps = {
	defaultCollapsed: boolean;
	isNav4CollapseReminderSpotlightActive: boolean;
	setIsNav4CollapseReminderSpotlightActive: React.Dispatch<React.SetStateAction<boolean>>;
};

export const TopNav = ({
	defaultCollapsed,
	isNav4CollapseReminderSpotlightActive,
	setIsNav4CollapseReminderSpotlightActive,
}: TopNavProps): React.JSX.Element => {
	const { data, error } = useQueryInterop<ThemeQueryData>(ThemeQuery);

	const horizontalHeader = data?.lookAndFeel?.custom?.horizontalHeader;
	const customTheme = useCustomTheme(
		horizontalHeader?.backgroundColor,
		horizontalHeader?.primaryNavigation?.highlightColor,
	);

	return (
		<AkTopNav testId="grid-topNav" customTheme={customTheme}>
			<UFOSegment name="top-nav">
				<TopNavigationBase
					defaultCollapsed={defaultCollapsed}
					customTheme={customTheme}
					isNav4CollapseReminderSpotlightActive={isNav4CollapseReminderSpotlightActive}
					setIsNav4CollapseReminderSpotlightActive={setIsNav4CollapseReminderSpotlightActive}
				/>
				{/* FIXME: Why is this in TopNav or @confluence/page-layout at all? Can it be moved to @confluence/global-components? */}
				<LazyImpersonationFlag />
			</UFOSegment>
			{error && <ErrorDisplay error={error} />}
		</AkTopNav>
	);
};
